import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { SiteContentProvider } from "@/context/SiteContentContext";
import Home from "@/pages/Home";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import ProductLineDetail from "@/pages/ProductLineDetail";
import FlavorDetail from "@/pages/FlavorDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Parceiros from "@/pages/Parceiros";
import OndeEstamos from "@/pages/OndeEstamos";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerRegister from "@/pages/CustomerRegister";
import CustomerAccount from "@/pages/CustomerAccount";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <AdminAuthProvider>
                <CustomerAuthProvider>
                    <SiteContentProvider>
                        <CartProvider>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/linhas/:lineId" element={<ProductLineDetail />} />
                                    <Route path="/sabores/:flavorId" element={<FlavorDetail />} />
                                    <Route path="/parceiros" element={<Parceiros />} />
                                    <Route path="/onde-estamos" element={<OndeEstamos />} />
                                    <Route path="/success" element={<Success />} />
                                    <Route path="/cancel" element={<Cancel />} />
                                    <Route path="/admin/login" element={<AdminLogin />} />
                                    <Route path="/admin" element={<AdminDashboard />} />
                                    <Route path="/conta/entrar" element={<CustomerLogin />} />
                                    <Route path="/conta/registar" element={<CustomerRegister />} />
                                    <Route path="/conta" element={<CustomerAccount />} />
                                    <Route path="*" element={<NotFound />} />
                                </Routes>
                            </BrowserRouter>
                            <Toaster position="top-right" richColors closeButton />
                        </CartProvider>
                    </SiteContentProvider>
                </CustomerAuthProvider>
            </AdminAuthProvider>
        </div>
    );
}

export default App;
